import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui";
import ProjectCard from "../components/ProjectCard";
import Lightbox from "../components/Lightbox";
import { PageHero } from "./About";
import SEO from "../components/SEO";

const FILTERS = ["All", "Elevation", "Interior", "Floor Plan", "3D Floor Plan", "Construction", "Completed Projects", "Renovation"];

export default function Projects() {
  const [params, setParams] = useSearchParams();
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState(params.get("tag") || "All");
  const [visible, setVisible] = useState(12);
  const [lb, setLb] = useState({ items: [], index: null });

  useEffect(() => { api.get("/projects?limit=200").then((r) => setProjects(r.data.items || [])); }, []);
  useEffect(() => { setFilter(params.get("tag") || "All"); }, [params]);

  const filtered = useMemo(() => filter === "All" ? projects : projects.filter((p) => (p.tags || []).includes(filter)), [projects, filter]);

  const setF = (f) => { setVisible(12); if (f === "All") setParams({}); else setParams({ tag: f }); };
  const openLightbox = (i) => setLb({ items: filtered.map((p) => ({ url: p.cover_image, name: p.name, category: p.tags?.[0], slug: p.slug })), index: i });

  return (
    <>
      <SEO title="Projects" description="Explore GNONS architecture, interior, elevation and construction projects in Indore." />
      <PageHero kicker="Our Projects" title="Work That Speaks for Itself" subtitle="From concept to completion — explore our portfolio." />

      <section className="py-16 md:py-20 bg-white">
        <div className="container-x">
          <div className="flex gap-2 md:gap-3 overflow-x-auto no-scrollbar pb-2 mb-8 -mx-5 px-5 md:mx-0 md:px-0" data-testid="projects-filters">
            {FILTERS.map((f) => (
              <button key={f} onClick={() => setF(f)} data-testid={`pfilter-${f.toLowerCase().replace(/\s/g, "-")}`}
                className={`shrink-0 px-5 py-2.5 rounded-full text-sm font-medium border transition-all duration-300 ${filter === f ? "bg-ink text-white border-ink" : "bg-white text-ink border-line hover:border-gold hover:text-gold"}`}>
                {f}
              </button>
            ))}
          </div>

          {filtered.length === 0 ? (
            <p className="text-center text-muted py-16">No projects in this category yet.</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
              {filtered.slice(0, visible).map((p, i) => (
                <ProjectCard key={p.id} project={p} cursorFollow={p.featured} onOpen={() => openLightbox(i)} aspect="aspect-[4/5]" />
              ))}
            </div>
          )}

          {visible < filtered.length && (
            <div className="text-center mt-10"><Button variant="dark" icon={false} onClick={() => setVisible((v) => v + 9)} data-testid="projects-load-more">Load More Projects</Button></div>
          )}
        </div>
      </section>

      <Lightbox items={lb.items} index={lb.index} onClose={() => setLb({ items: [], index: null })} onIndex={(i) => setLb((s) => ({ ...s, index: i }))} />
    </>
  );
}
